import { render, staticRenderFns } from "./schedulingTypeForm.vue?vue&type=template&id=d854a50a&scoped=true"
import script from "./schedulingTypeForm.vue?vue&type=script&lang=js"
export * from "./schedulingTypeForm.vue?vue&type=script&lang=js"
import style0 from "./schedulingTypeForm.vue?vue&type=style&index=0&id=d854a50a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d854a50a",
  null
  
)

export default component.exports